import "./Trip.css";

import React from "react";

const TripData = (props) => {
  return (
    <div className="t-card">
      <div className="t-image">
        <img src={props.image} alt="" />
      </div>

      <h4>{props.heading}</h4>
      <p>{props.text}</p>
      <div style={{marginTop: '20px', fontWeight: '600'}}>
        <button>Explore More</button>
      </div>
    </div>
  );
};

export default TripData;
